import * as actions from "./actions";
import updateObject from "../Utilities/updateObject";
import { hippsCategories } from "./hippsCategories";
const initialState = {
  isLoading: false,
  user: null,
  activeFacilities: null,
  allFacilities: null,
  groups: null,
  ivfluids: [],
  isChildGroup: false,
  currentGroup: null,
  HIPPSCategories: hippsCategories,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.UPDATE:
      return updateObject(state, { [action.field]: action[action.field] });
    case actions.LOGOUT:
      return { ...initialState, isLoading: false };
    default:
      return state;
  }
};

export default reducer;
